<template>
	<!-- 签到首页 -->
	<div>
		<!-- <van-nav-bar 
			title="连续签到领金币"
			left-arrow
			@click-left="onClickLeft"/> -->
		<div class="f-ajc rel">
			
			
			<!-- <div class="sign tc-f" v-if="isSign">
				<div>已签到</div>
				<div>连续1天</div>
			</div> -->
			<div style="background-color: #666;" class="sign tc-f" v-if="isSign===true" >今日已签到</div>
			<div class="sign tc-f" @click="sign" v-else-if="isSign===false">签到</div>
			<div class="info" @click="toInfo">明细</div>
		</div>
		<div class="ta-c tip-text" style="color: #eb3223;font-weight: bold;">今日已获得贡献值：{{points}}</div>
		<div class="ta-c tip-text">连续7天获得更多贡献值</div>
		<div class="cal">
			<calendar :dataSource="dataSource" @dateChange="dateChange"></calendar>
		</div>
		<div class="cal">
			<div class="tip">
				<div class="t">贡献值签到规则</div>
				<div class="content" >
					<p>1、当日重复签到不会重复计数。</p>
					<p>2、连续签到，获得贡献值加速。第一次签到得8分，第二次为16分，第三次为32分，第四次为64分，最高为568分。以此类推。</p>
					<p>3、当连续签到中断后，之前攒下的贡献值会保留，不会清零，但会重新累计连续签到次数。</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import calendar from '../../components/calendar/calendar/calendar.vue';
	import { Toast } from 'vant';
	export default {
	  name: "",
	  data() {
	    return {
			isload:false,
			dataSource: [],
			userId:0,
			isSign:false,
			y :'',
			m :'',
			d :'',
			ymd :'',
			ctm :'',
			points:0,
			
	    };
	  },
	  components:{
		  calendar
	  },
	  created() {
	  	// 默认展示当前年月的签到情况
			let y = new Date().getFullYear();
	  	    let m = new Date().getMonth() + 1;
	  	    let d = new Date().getDate();
	  		this.y= y;
			this.m= m;
			this.d= d;
			this.ymd= y+'-'+m+'-'+d;
			this.ctm = y+"-"+m;
			this.userId = this.$route.query.userId;
			// 获取签到记录
			this.getList(y+"-"+m);
			
	  },
	  mounted() {
	  	 document.querySelector('body').setAttribute('style', 'background-color:#f8f8f8');
		 document.querySelector('title').innerText = '连续签到领贡献值';
		
	  },
	methods: {
		// 查看签到历史
		dateChange(e) {
			this.ctm = e;
			this.getList(e)
		},
		//签到详情
		toInfo(){
			this.$router.push({path:"/sign-info",query:{userId:this.userId,sendTm:this.ctm}})
		},
	   // 获取签到记录
		async getList(sendTm){
			// 自定义加载图标
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let params = {
				userId:this.userId,
				sendTm
			}
			let res = await this.$axios.post('common/v1/ContribDetail/list',params);
			console.log('data',res);
			if(res.data.success){
				Toast.clear();
				let month = [];
				res.data.data.forEach((item,index)=>{
					let m = this.$util.dateFormat(new Date(item.sendTm),'M');
					let d = this.$util.dateFormat(new Date(item.sendTm),'d');
					let y = this.$util.dateFormat(new Date(item.sendTm),'yyyy');
					let ymd= y+'-'+m+'-'+d;
					console.log('ym',this.ymd ,ymd);
					if(this.ymd == ymd){
						this.isSign = true;
						this.points = item.points;
					}
					month.push({
						day:d,
						num:item.points
					})
				})
				// this.isSign = this.isSign===''?false:true;
				console.log('month',month);
				this.dataSource = month;
			}else{
				Toast.clear();
				// Toast();
			}
		},
		async sign(){
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let params = {
				userId:this.userId
			}
			let res = await this.$axios.post("common/v1/ContribDetail/sendContribDetail",params);
			if(res.data.success){
				Toast.clear();
				this.isSign = true;
				this.getList(this.ctm);
				Toast('签到成功');
			}else{
				Toast.clear();
			}
		},
		onClickLeft(){
			this.$router.push('/');
		}
	}
};
</script>

<style lang="less" scoped>
	.rel{
		position: relative;
		.info{
			position: absolute;
			right: 15px;
			top: 15px;
			font-size: 16px;
			color: #1468ff;
		}
	}
	.sign{
		width: 6.25rem;
		height:  6.25rem;
		background-color: #ee6f2d;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		margin: 1.25rem 0;
		border-radius: 600px;
		&>div:nth-child(1){
			// border-bottom: 0.03125rem solid #FFFFFF;
			padding-bottom: 0.35rem;
			position: relative;
			&::after{
				content: '';
				position: absolute;
				left: -0.6rem;
				bottom: 0px;
				width: 4rem;
				height: 0.0625rem;
				z-index: 9;
				background-color: #FFFFFF;
			}
		}
		&>div:nth-child(2){
			padding-top: 0.35rem;
			font-size: 0.8125rem;
		}
	}
	.tip-text{
		font-size: 1rem;
	}
	.cal{
		margin: 0.625rem 0.625rem;
	}
	.tip{
		background-color: #FFFFFF;
		border-radius: 0.3125rem;
		.t{
			font-size: 1rem;
			text-align: center;
			padding: 0.625rem;
			border-bottom: 0.0625rem solid #DBDBDB;
		}
		.content{
			font-size: 0.875rem;
			padding: 0.625rem 1.875rem;
			p{
				line-height: 1.2;
				margin: 0.3125rem 0;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/integral/sign.vue